import React, { useEffect, useState } from 'react'
import { getLessonCurrentLevelCounts, getLessonFutureLevelCounts, getOverviewTexts, saveOverviewTexts } from '../../../lib/studentgparigorsummary'
import { ReportCard, ToastNotification, OverviewTextarea, UpdateButton } from './CourseReportComponents'
import { getHeaderClass, sortLevels } from './CourseReportUtils'
import style from './CourseReportStyles.module.css'

export const CourseLoadSummary = ({ studentId, isStudent = false }) => {
	const [current, setCurrent] = useState({})
	const [future, setFuture] = useState({})
	const [levels, setLevels] = useState([])
	const [overview, setOverview] = useState({})
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	useEffect(() => {
		loadData()
	}, [studentId])

	const loadData = async () => {
		const currentRes = await getLessonCurrentLevelCounts(studentId)
		const futureRes = await getLessonFutureLevelCounts(studentId)
		const overviewRes = await getOverviewTexts(studentId)

		const currentMap = {}
		const futureMap = {}
		const levelSet = new Set()

		currentRes.forEach((item) => {
			currentMap[item.level] = (currentMap[item.level] || 0) + item.count
			levelSet.add(item.level)
		})

		futureRes.forEach((item) => {
			futureMap[item.level] = (futureMap[item.level] || 0) + item.count
			levelSet.add(item.level)
		})

		const overviewMap = {}
		overviewRes.forEach((item) => {
			overviewMap[item.type] = item.desc
		})

		setCurrent(currentMap)
		setFuture(futureMap)
		setOverview(overviewMap)
		setLevels(sortLevels([...levelSet]))
	}

	const handleOverviewChange = (value) => {
		setOverview((prev) => ({ ...prev, clevel: value }))
	}

	const handleUpdate = async () => {
		await saveOverviewTexts(studentId, { clevel: overview.clevel || '' })
		showToastMessage('Update successful!')
		loadData()
	}

	const getTotal = (type) =>
		levels.reduce((sum, level) => sum + (type === 'current' ? parseFloat(current[level] || 0) : parseFloat(future[level] || 0)), 0)

	return (
		<ReportCard title="Course Load">
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />

			<div>
				<table className="table table-bordered text-center">
					<thead>
						<tr>
							<th style={{ width: '150px' }}></th>
							<th>Tot.</th>
							{levels.map((lvl) => (
								<th key={lvl} className={style[getHeaderClass(lvl)]}>
									{lvl}
								</th>
							))}
							<th style={{ width: '400px' }}>Overview</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Current</td>
							<td className={style.totalCell}>{getTotal('current')}</td>
							{levels.map((lvl) => (
								<td key={lvl} className={current[lvl] > 0 ? style[getHeaderClass(lvl)] : ''}>
									{current[lvl] ?? 0}
								</td>
							))}
							<td rowSpan={3} className={style.overviewCell}>
								<div className="h-100 w-100 d-flex flex-column justify-content-between">
									<OverviewTextarea value={overview['clevel'] || ''} onChange={handleOverviewChange} rows={6} isStudent={isStudent} />
								</div>
							</td>
						</tr>
						<tr>
							<td>Future</td>
							<td className={style.totalCell}>{getTotal('future')}</td>
							{levels.map((lvl) => (
								<td key={lvl} className={future[lvl] > 0 ? style[getHeaderClass(lvl)] : ''}>
									{future[lvl] ?? 0}
								</td>
							))}
						</tr>
						<tr>
							<td>Total</td>
							<td className={style.totalCell}>{getTotal('current') + getTotal('future')}</td>
							{levels.map((lvl) => (
								<td key={lvl} className={((current[lvl] || 0) + (future[lvl] || 0) > 0 ? style[getHeaderClass(lvl)] : '') + ' fw-bold'}>
									{(current[lvl] || 0) + (future[lvl] || 0)}
								</td>
							))}
						</tr>
					</tbody>
				</table>

				<UpdateButton onClick={handleUpdate} isStudent={isStudent} />
			</div>
		</ReportCard>
	)
}
